import { useContext } from 'react'
import { MixpanelContext } from '@/components/mixpanel/context'

export const useMixpanel = () => useContext(MixpanelContext)
